import React from "react";

import BackpackIcon from "@mui/icons-material/Backpack";

function PackageIcon({ iconColor, iconSize = "small", ...other }) {
    return <BackpackIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default PackageIcon;
